/* eslint-disable no-throw-literal */
/* eslint-disable no-undef */
import { createCookie, readCookie } from 'utils/cookies';

import Constants from 'utils/Constants';
import axios from 'axios';
import { show } from 'redux/reducers/snackbar';
import { store } from 'redux/store';
import { logoutPublicUser } from 'redux/reducers/publicUser';

// import Constants from 'utils/Constants';
const ERROR = {
  502: 'Server is busy. Please try again later.',
  network: 'Network Error',
};
const handleRequest = async ({ res, error }, dispatch) => {
  try {
    if (error) {
      if (error?.response?.status) {
        switch (error.response.status) {
          case 502:
            dispatch &&
              dispatch(
                show({
                  message: ERROR[502],
                  severity: 'error',
                }),
              );
            throw ERROR[502];
          default:
        }
      }
      switch (error.message) {
        case 'Network Error':
          dispatch &&
            dispatch(
              show({
                message: ERROR.network,
                severity: 'error',
              }),
            );
          throw 'Network Error';
        default:
          throw error.response?.data?.message || error.message;
      }
    }

    let authorization = res.headers.authorization;
    if (authorization) {
      let access_token = authorization.split(' ')[1];
      let oldAccessToken = readCookie(Constants.PUBLIC_USER_ACCESS_TOKEN);
      if (access_token && access_token !== oldAccessToken) {
        createCookie(Constants.PUBLIC_USER_ACCESS_TOKEN, access_token);
      }
    }
    if (res.data.error_code) {
      if ([2006].includes(res.data.error_code)) {
        dispatch && dispatch(logoutPublicUser());
        store.dispatch(logoutPublicUser());
      }
      if (res.data.error_code === 1103 && dispatch) {
        // dispatch && dispatch(logout());
        setTimeout(() => {
          dispatch &&
            dispatch(
              show({
                message: res.data.error_message,
                severity: 'error',
              }),
            );
        }, 1000);
      }
      if (res.data.error_detail) {
        throw res.data.error_detail;
      }
      throw res.data.error_message;
    }
  } catch (err) {
    // console.log('handleRequest', err);
    if (typeof err === 'string') {
      throw err;
    }
    throw JSON.stringify(err?.message);
  }
};
export default class Client {
  constructor(server = process.env.REACT_APP_BACKEND_URL) {
    this.url = (server || window.location.origin) + '/';
    this.client = axios.create({
      baseURL: this.url,
      headers: {
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': true,
        // Authorization: `Bearer ${readCookie(Constants.ACCESS_TOKEN)}`,
      },
    });

    this.client.interceptors.request.use(async (config) => {
      let access_token = readCookie(Constants.PUBLIC_USER_ACCESS_TOKEN);

      config.headers.Authorization = `Bearer ${access_token}`;
      return config;
    });
  }

  async get(url, payload, dispatch) {
    let res = {};
    try {
      res = await this.client.get(url, payload || {});
    } catch (error) {
      await handleRequest({ error }, dispatch);
    }
    await handleRequest({ res }, dispatch);
    return res;
  }

  async post(url, payload, config, dispatch) {
    let res = {};
    try {
      res = await this.client.post(url, payload || {}, config);
    } catch (error) {
      await handleRequest({ error }, dispatch);
      return;
    }
    await handleRequest({ res }, dispatch);
    return res;
  }
  async delete(url, payload, dispatch) {
    let res = {};
    try {
      res = await this.client.delete(url, payload || {});
    } catch (error) {
      await handleRequest({ error }, dispatch);
    }
    await handleRequest({ res }, dispatch);
    return res;
  }
  async put(url, payload, config, dispatch) {
    let res = {};
    try {
      res = await this.client.put(url, payload || {}, config);
    } catch (error) {
      await handleRequest({ error }, dispatch);
    }
    await handleRequest({ res }, dispatch);
    return res;
  }
  async patch(url, payload, config, dispatch) {
    let res = {};
    try {
      res = await this.client.patch(url, payload || {}, config);
    } catch (error) {
      await handleRequest({ error }, dispatch);
    }
    await handleRequest({ res }, dispatch);
    return res;
  }
}
